var map = {
	"./Slide 1.jpg": 1706,
	"./Slide 10.jpg": 9715,
	"./Slide 11.jpg": 1740,
	"./Slide 12.jpg": 9826,
	"./Slide 13.jpg": 4498,
	"./Slide 14.jpg": 5866,
	"./Slide 15.jpg": 8118,
	"./Slide 16.jpg": 7388,
	"./Slide 17.jpg": 7403,
	"./Slide 18.jpg": 7841,
	"./Slide 19.jpg": 4652,
	"./Slide 2.jpg": 9811,
	"./Slide 20.jpg": 1727,
	"./Slide 3.jpg": 3105,
	"./Slide 4.jpg": 3213,
	"./Slide 5.jpg": 2478,
	"./Slide 6.jpg": 4729,
	"./Slide 7.jpg": 9919,
	"./Slide 8.jpg": 472,
	"./Slide 9.jpg": 3623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4762;